import React, { useState } from "react";
import "./WhatsnewContent.css";
import Modal from "react-modal";

function WhatsnewContent(props) {
  const [whatsVal, setWhatsVal] = useState("w_new");
  const [showModal, setShowModal] = useState(false);
  const [activeModal, setActiveModal] = useState("");

  React.useEffect(() => {
    setWhatsVal(props.menu2);
  }, [props.menu2]);

  const handleOpenModal = (val) => {
    setActiveModal(val);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal("");
  };
  return (
    <>
      <div className="whatsnew-container">
        <div className="whatsnew-wrap">
          <div className="whatsnew-row row2">
            {/* <h2 className="main-head">
              <span className="sub-head">
                Fulfill ATCI's enormous upskilling demands to consistently
                transform ATCI's talent and enable growth across key tracks.
              </span>
            </h2> */}

            <div className="whatsnew-box">
              <div class="tab-content" id="v-pills-tabContent-3">
                <div className="whats-container">
                  <h2 className="whats-heading" tabIndex={0}>
                    Automation Architect and ARC
                  </h2>
                  <div className="whats-wrap">
                    <div
                      className={
                        props.menu3 === "AccentureReinventionConsole"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>
                          Accenture Reinvention <br /> Console
                        </h3>
                        <p>
                          Accenture Reinvention Console and Solution Tablets
                          bring the best of our Asset and Offerings
                          differentiation to deliver the 360˚ value for clients{" "}
                        </p>
                        <p>
                          {" "}
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <div onClick={() => handleOpenModal("imageARC")}>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <Modal
                          isOpen={showModal && activeModal === "imageARC"}
                          onRequestClose={() => setShowModal(false)}
                          // contentLabel="login Modal"
                          style={{
                            overlay: {
                              backgroundColor: "rgba(0, 0, 0, 0.75)",
                            },
                          }}
                        >
                          <button
                            className="closebtn"
                            onClick={handleCloseModal}
                          >
                            X
                          </button>
                          <h3>Accenture Reinvention Console</h3>
                          <p>
                            Accenture Reinvention Console and Solution Tablets
                            bring the best of our Asset and Offerings
                            differentiation to deliver the 360˚ value for
                            clients - industry-focused, seamless, efficient, and
                            highly personalized.
                          </p>
                          <h3>Workshop Agenda</h3>
                          <ul>
                            <li>
                              Explore the Reinvention console to search and find
                              the right solution tablets and assets for a client
                              challenge.
                            </li>
                            <li>
                              Personalize their solution tablets to create a
                              customized workspace for their client challenge
                            </li>
                            <li>
                              Create a personalized client transformation
                              journey using the selected solution tablets and
                              assets in their workspace
                            </li>
                            <li>
                              Browse through the asset adoption index dashboard
                              and understand current adoption of solutions and
                              assets in their MU
                            </li>
                            <li>
                              Target Audience: ATCI CALs, Sales leads, Solution
                              leads, Delivery leads
                            </li>
                            <li>Training Mode: Virtual - MS teams</li>
                          </ul>
                          <button className="close" onClick={handleCloseModal}>
                            Close
                          </button>
                        </Modal>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="whats-container">
                  <h2 className="whats-heading" tabIndex={0}>Custom Engineering</h2>

                  <div className="whats-wrap">
                    <div
                      className={
                        props.menu3 ===
                        "JavaFullStackDevelopmentusingSpringandReact"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>
                          Java Full Stack <br /> Development using <br /> Spring
                          and React
                        </h3>
                        <p>
                          An instructor-led program covering Declarative Java,
                          JPA, Spring Stack and Consuming Spring Boot apps using
                          React.
                        </p>
                        <p>
                          <a
                            href="mailto:r.c.narayanan" aria-label="mailto:r.c.narayanan"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <div onClick={() => handleOpenModal("imageSR3")}>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <Modal
                          isOpen={showModal && activeModal === "imageSR3"}
                          onRequestClose={() => setShowModal(false)}
                          // contentLabel="login Modal"
                          style={{
                            overlay: {
                              backgroundColor: "rgba(0, 0, 0, 0.75)",
                            },
                          }}
                        >
                          <button
                            className="closebtn"
                            onClick={handleCloseModal}
                          >
                            X
                          </button>
                          <h3>
                            Java Full Stack Development using Spring and React
                          </h3>
                          <p>
                            It is a holistic instructor-led program of 15 days
                            /135 hours that enables participants to learn how to
                            create and design highly cohesive and loosely
                            coupled Java applications using:
                          </p>
                          <ul>
                            <li>Declarative Java and JPA</li>
                            <li>Spring Stack and Spring Boot microservices</li>
                            <li>
                              Microservices Design Patterns with Spring Cloud
                            </li>
                            <li>
                              React with Axios to consume Spring Boot based
                              microservices.
                            </li>
                          </ul>
                          <p>This course composes of following modules:</p>
                          <ul>
                            <li>Declarative Java and JPA.</li>
                            <li>
                              Spring Stack and Spring Boot microservice
                              essentials.
                            </li>
                            <li>
                              Microservices Design Patterns with Spring Cloud
                              and Consuming Microservices using React. This
                              program enables the participants to be Java
                              full-stack engineers.
                            </li>
                          </ul>
                          <button className="close" onClick={handleCloseModal}>
                            Close
                          </button>
                        </Modal>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <div
                      className={
                        props.menu3 ===
                        "JavaSpringBootMicroserviceApplicationDeveloper"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>
                          Java Spring Boot Microservice Application Developer
                        </h3>
                        <p>
                          An advanced program covering Spring Stack and
                          microservices
                        </p>
                        <p>
                          <a
                            href="mailto:r.c.narayanan" aria-label="mailto:r.c.narayanan"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <div onClick={() => handleOpenModal("imageJSBM3")}>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <Modal
                          isOpen={showModal && activeModal === "imageJSBM3"}
                          onRequestClose={() => setShowModal(false)}
                          // contentLabel="login Modal"
                          style={{
                            overlay: {
                              backgroundColor: "rgba(0, 0, 0, 0.75)",
                            },
                          }}
                        >
                          <button
                            className="closebtn"
                            onClick={handleCloseModal}
                          >
                            X
                          </button>
                          <h3>
                            Java Spring Boot Microservice Application Developer
                          </h3>
                          <p>
                            It is an advanced 90-hour program split into 2
                            parts:
                          </p>
                          <h4>
                            Spring Stack and Spring Boot microservice
                            essentials:
                          </h4>
                          <ul>
                            <li>
                              This part covers the details about Spring Stack
                              (core, Test, ORM, MVC, Security) and Spring Boot.{" "}
                            </li>
                          </ul>
                          <h4>
                            Microservices Design Patterns with Spring Cloud:
                          </h4>
                          <ul>
                            <li>
                              This part covers the details of microservice
                              architecture and guides on how to implement
                              microservices using Spring Boot. It also focuses
                              on various microservice design patterns and
                              automation using Spring Cloud.
                            </li>
                            <li>
                              This program also focuses on deploying the Spring
                              boot microservice components on the AWS cloud.
                            </li>
                            <li>
                              This program enables participants to be
                              microservice application developers.
                            </li>
                          </ul>
                          <button className="close" onClick={handleCloseModal}>
                            Close
                          </button>
                        </Modal>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <div
                      className={
                        props.menu3 ===
                        "CreatingMicroserviceComponentsUsingSpringBootandAngular11"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>
                          Creating Microservice Components Using Spring Boot and
                          Angular11
                        </h3>
                        <p>
                          An advanced program covering creation of microservice
                          components using Spring Boot and consuming
                          microservices components from Angular 11
                        </p>
                        <p>
                          <a
                            href="mailto:r.c.narayanan" aria-label="mailto:r.c.narayanan"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <div onClick={() => handleOpenModal("imageAT3")}>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <Modal
                          isOpen={showModal && activeModal === "imageAT3"}
                          onRequestClose={() => setShowModal(false)}
                          // contentLabel="login Modal"
                          style={{
                            overlay: {
                              backgroundColor: "rgba(0, 0, 0, 0.75)",
                            },
                          }}
                        >
                          <button
                            className="closebtn"
                            onClick={handleCloseModal}
                          >
                            X
                          </button>
                          <h3>
                            Creating Microservice Components Using Spring Boot
                            and Angular11
                          </h3>
                          <p>
                            In this 3day/ 27 hour program, participants would be
                            able to:{" "}
                          </p>
                          <ul>
                            <li>
                              Comprehend Microservices Architecture Best
                              Practice{" "}
                            </li>
                            <li>
                              Write Loosely Coupled and Highly Cohesive Code
                            </li>
                            <li>
                              Differentiate between Microservices and Monolithic
                              Architecture{" "}
                            </li>
                            <li>
                              Know 12 Factor App and SOLID Principle for
                              Microservices Based applications
                            </li>
                            <li>
                              Creating micro service components using SpringBoot{" "}
                            </li>
                            <li>
                              Understand Basics of Angular and Angualr
                              Architecture
                            </li>
                            <li>Use Angular Modules and Components</li>
                            <li>
                              Use Angular Data binding, Directives , Services,
                              Routing{" "}
                            </li>
                            <li>Create and Use Angular Forms</li>
                            <li>
                              Consume Spring Boot Micro service components to
                              perform CRUD operations from Angular 11
                              application
                            </li>
                          </ul>
                          <button className="close" onClick={handleCloseModal}>
                            Close
                          </button>
                        </Modal>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="whats-container">
                  <h2 className="whats-heading" tabIndex={0}>
                    Enterprise Application Integration (EAI)
                  </h2>
                  <div className="whats-wrap">
                    <div
                      className={
                        props.menu3 === "MulesoftExpertProgram"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>Mulesoft Expert Program</h3>
                        <p>
                          Gain expertise in Mulesoft Anypoint Platform
                          Development
                        </p>
                        <p>
                          <a
                            href="mailto:rahul.suresh.ghali" aria-label="mailto:rahul.suresh.ghali"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://kxdocuments.accenture.com/contribution/d69f7899-d2b6-4eff-8339-a525973cf41c"
                            target="_blank"
                          >
                            Know More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="whats-container">
                  <h2 className="whats-heading" tabIndex={0}>
                    Infrastructure Engineering (IE)
                  </h2>
                  <div className="whats-wrap">
                    <div
                      className={
                        props.menu3 === "MultiSkillingProgram"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>Multi Skilling Program</h3>
                        <p>
                          Multi Skilling is a concept of NEW IT. The expectation
                          in the Infrastructure world is for an engineer to
                          develop & demonstrate expertise on multiple IT skills.{" "}
                        </p>
                        <p>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://atci.lkm.delivery.accenture.com/MSE/"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>

                    <div
                      className={
                        props.menu3 === "NetworkArchitect"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>Network Architect</h3>
                        <p>
                          This program has been structured keeping in mind the
                          changing role of the network leads with an emphasis on
                          building technology skills.
                        </p>
                        <p>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <div onClick={() => handleOpenModal("image88")}>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <Modal
                      isOpen={showModal && activeModal === "image88"}
                      onRequestClose={() => setShowModal(false)}
                      // contentLabel="login Modal"
                      style={{
                        overlay: {
                          backgroundColor: "rgba(0, 0, 0, 0.75)",
                        },
                      }}
                    >
                      <button className="closebtn" onClick={handleCloseModal}>
                        X
                      </button>
                      <h3>Network Architect</h3>
                      <p>The program includes:</p>
                      <ul>
                        <li>SD-WAN</li>
                        <li>SASE</li>
                        <li>DC Network</li>
                        <li>Cloud Contact Center</li>
                        <li>Wireless</li>
                        <li>Cloud Networks</li>
                        <li>DevOps</li>
                        <li>Business & Soft Skills</li>
                        <li>Framework & Management</li>
                      </ul>
                      <button className="close" onClick={handleCloseModal}>
                        Close
                      </button>
                    </Modal>
                  </div>
                </div>

                <div className="whats-container">
                  <h2 className="whats-heading" tabIndex={0}>Quality Engineering</h2>
                  <div className="whats-wrap">
                    <div
                      className={
                        props.menu3 === "ScriptlesstestAutomationusingTosca"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>
                          Scriptless test <br /> Automation using Tosca
                        </h3>
                        <p>Tosca scriptless testing features and API</p>
                        <p>
                          <a
                            href="mailto:sheela.t.ganesh" aria-label="mailto:sheela.t.ganesh"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://deepknowledge.accenture.com/course/view.php?id=91"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="whats-container">
                  <h2 className="whats-heading" tabIndex={0}>Security</h2>
                  <div className="whats-wrap">
                    <div
                      className={
                        props.menu3 === "AccentureSecurityInternshipProgram"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>Accenture Security Internship Program </h3>
                        <p>
                          A program for college interns to understand the
                          importance of security practices
                        </p>
                        <p>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <div onClick={() => handleOpenModal("image11")}>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <Modal
                      isOpen={showModal && activeModal === "image11"}
                      onRequestClose={() => setShowModal(false)}
                      // contentLabel="login Modal"
                      style={{
                        overlay: {
                          backgroundColor: "rgba(0, 0, 0, 0.75)",
                        },
                      }}
                    >
                      <button className="closebtn" onClick={handleCloseModal}>
                        X
                      </button>
                      <h3>Accenture Security Internship Program </h3>
                      <p>
                        A program designed to help college interns understand
                        the foundational aspects of security to help them build
                        technical skills and make them job-ready before they
                        join as FTEs
                      </p>
                      <button className="close" onClick={handleCloseModal}>
                        Close
                      </button>
                    </Modal>
                    <div
                      className={
                        props.menu3 === "Cyberbit"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>Cyberbit 2.0</h3>
                        <p>
                          Build hands-on cybersecurity practice to face
                          real-life cyber security threats
                        </p>
                        <p>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        {/* <div onClick={() => handleOpenModal("image10")}>
                                                        <a href="mailto:gajendra.mallik" className='left-side-link' target="_blank"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a>
                                                        <a className='right-side-link'>View More <img src="images/Home/Explore arrow.png" alt="" /></a>
                                                    </div> */}
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    {/* <Modal
                                                isOpen={
                                                    showModal &&
                                                    activeModal === "image10"
                                                }
                                                onRequestClose={() => setShowModal(false)}
                                                // contentLabel="login Modal"
                                                style={{
                                                    overlay: {
                                                        backgroundColor: 'rgba(0, 0, 0, 0.75)'
                                                    }
                                                }}
                                            >
                                                <button className="closebtn" onClick={handleCloseModal}>X</button>
                                                <h3>Cyberbit 2.0</h3>
                                                <p>This program enables learners to build hands-on cybersecurity practice to face real-life cyber security threats in a controlled simulated learning environment. It consists of five tiers, each escalating in terms of skills and technical depth. <a href='https://atci.lkm-securitylearnings.accenture.com/Cyberbit/home' target='_blank'>Click Here</a></p>
                                                <button className="close" onClick={handleCloseModal}>Close</button>
                                            </Modal> */}
                    <div
                      className={
                        props.menu3 === "CyberHER"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>CyberHER '23</h3>
                        <p>
                          Security certification program for women technologists
                          of career level 9 and above
                        </p>
                        <div onClick={() => handleOpenModal("imageCH10")}>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <Modal
                      isOpen={showModal && activeModal === "imageCH10"}
                      onRequestClose={() => setShowModal(false)}
                      // contentLabel="login Modal"
                      style={{
                        overlay: {
                          backgroundColor: "rgba(0, 0, 0, 0.75)",
                        },
                      }}
                    >
                      <button className="closebtn" onClick={handleCloseModal}>
                        X
                      </button>
                      <h3>CyberHER '23</h3>
                      <p>
                        Security certification program for women technologists
                        aims to engage and provide opportunities to CL9 and
                        above women across markets to learn application security
                        concepts to develop secure software and acquire the
                        industry’s premier secure software development
                        certification – Certified Secure Software Lifecycle
                        Professional (CSSLP) and help secure the world.
                      </p>
                      <button className="close" onClick={handleCloseModal}>
                        Close
                      </button>
                    </Modal>
                    <div
                      className={
                        props.menu3 === "Cybersecurityessentialsforbeginners"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>
                          Cybersecurity essentials <br /> for beginners
                        </h3>
                        <p>
                          It is a program designed for professionals outside
                          Security capability to start their journey in the
                          Cybersecurity domain.{" "}
                        </p>
                        <div onClick={() => handleOpenModal("imageCEB10")}>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <Modal
                      isOpen={showModal && activeModal === "imageCEB10"}
                      onRequestClose={() => setShowModal(false)}
                      // contentLabel="login Modal"
                      style={{
                        overlay: {
                          backgroundColor: "rgba(0, 0, 0, 0.75)",
                        },
                      }}
                    >
                      <button className="closebtn" onClick={handleCloseModal}>
                        X
                      </button>
                      <h3>Cybersecurity essentials for beginners</h3>
                      <p>
                        It aims to provide a comprehensive understanding of
                        various concepts used in the world of information
                        security. This course aims to build key skills needed to
                        recognize common security threats and risks, discover
                        the characteristics of cyber-attacks, and learn how
                        organizations employ best practices to guard against
                        them.
                      </p>
                      <button className="close" onClick={handleCloseModal}>
                        Close
                      </button>
                    </Modal>
                  </div>
                  <div className="whats-wrap">
                    <div
                      className={
                        props.menu3 === "DeliveryAdeptAcademy"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>Delivery Adept Academy (DAA)</h3>
                        <p>
                          Delivery Adept Academy (DAA) for Security - ROLE based
                          learning aims to build the required security
                          specialization skills for delivering securely.
                        </p>
                        <p>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://atci.lkm-securitylearnings.accenture.com/DeliveryAdeptAcademy/"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        {/* <p><a href="mailto:gajendra.mallik" className='left-side-link' target="_blank"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                                    <div onClick={() => handleOpenModal("imageDAA9")}>
                                                        <a className='right-side-link'>View More <img src="images/Home/Explore arrow.png" alt="" /></a>
                                                    </div> */}
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>

                    <div
                      className={
                        props.menu3 === "IndustryLearning"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        {/* <h3>Security Learning</h3> */}
                        <h3>Industry Learning</h3>
                        <p>
                          A program designed to gain deep industry knowledge and
                          expertise.
                        </p>
                        <p>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://atci.lkm-securitylearnings.accenture.com/IndustryLearningAcademy/home"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <div
                      className={
                        props.menu3 === "LearningLabs"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>Learning Labs</h3>
                        <p>
                          Learning labs designed for experiential learning with
                          cloud labs.
                        </p>
                        <p>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <div onClick={() => handleOpenModal("imageLL9")}>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <Modal
                      isOpen={showModal && activeModal === "imageLL9"}
                      onRequestClose={() => setShowModal(false)}
                      // contentLabel="login Modal"
                      style={{
                        overlay: {
                          backgroundColor: "rgba(0, 0, 0, 0.75)",
                        },
                      }}
                    >
                      <button className="closebtn" onClick={handleCloseModal}>
                        X
                      </button>
                      <h3>Learning Labs</h3>
                      <p>
                        Learning Labs focuses on experiential learning with
                        cloud labs by creating a virtual, scalable simulated
                        environment for hands-on learning, practicing real-time
                        scenarios, and acquiring the skills required by the
                        projects.
                      </p>
                      <button className="close" onClick={handleCloseModal}>
                        Close
                      </button>
                    </Modal>
                    <div
                      className={
                        props.menu3 === "SailPointIIQtraining"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3>
                          SailPoint IIQ <br /> training
                        </h3>
                        <p>
                          It is a program designed to provide an in-depth
                          understanding of SailPoint IdentityIQ on IdentityIQ
                          architecture and its key features.
                        </p>
                        <p>
                          <a
                            href="mailto:gajendra.mallik" aria-label="mailto:gajendra.mallik"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <div onClick={() => handleOpenModal("imageSIT9")}>
                          <a className="right-side-link" tabIndex={0}>
                            View More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <Modal
                      isOpen={showModal && activeModal === "imageSIT9"}
                      onRequestClose={() => setShowModal(false)}
                      // contentLabel="login Modal"
                      style={{
                        overlay: {
                          backgroundColor: "rgba(0, 0, 0, 0.75)",
                        },
                      }}
                    >
                      <button className="closebtn" onClick={handleCloseModal}>
                        X
                      </button>
                      <h3>SailPoint IIQ training</h3>
                      <p>
                        The course provides a conceptual understanding necessary
                        to administer, implement and develop using the SailPoint
                        IdentityIQ Identity & Access Management Software. This
                        is a 100+ hours program hosted on SailPoint University
                        backed with regular SME connects and end-of-course
                        assessment.
                      </p>
                      <button className="close" onClick={handleCloseModal}>
                        Close
                      </button>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WhatsnewContent;
